import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Heading from 'components/Heading';
import InlineList from 'components/InlineList';
import Stack from 'components/Stack';
import Text from 'components/Text';
import Landmark from 'components/Landmark';
import MeetingItem from './MeetingItem';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function MeetingSection(_ref) {
  var _ref$userMeetings = _ref.userMeetings,
    userMeetings = _ref$userMeetings === void 0 ? [] : _ref$userMeetings,
    getLocation = _ref.getLocation,
    userId = _ref.userId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsxs("section", {
    "aria-labelledby": "meetings-this-week-heading",
    children: [/*#__PURE__*/_jsx(Heading, {
      as: "h3",
      size: "small",
      mb: "s",
      id: "meetings-this-week-heading",
      children: t('skills_title_meetings_this_week')
    }), (userMeetings === null || userMeetings === void 0 ? void 0 : userMeetings.length) === 0 ? /*#__PURE__*/_jsx(Landmark, {
      height: 100,
      children: /*#__PURE__*/_jsx(Text, {
        dimmed: true,
        children: t('amount_none')
      })
    }) : /*#__PURE__*/_jsx(Stack, {
      spacing: "xs",
      as: "list",
      children: userMeetings.map(function (meeting) {
        var startTime = new Date(meeting.startTime);
        var formattedDate = startTime.toLocaleDateString('en-GB', {
          dateStyle: 'medium'
        });
        var formattedTime = startTime.toLocaleTimeString('en-GB', {
          timeStyle: 'short',
          hour12: true
        });
        return /*#__PURE__*/_jsx(MeetingItem, {
          score: meeting.score,
          subtitle: /*#__PURE__*/_jsxs(InlineList, {
            splitBy: "dot",
            as: "p",
            itemAs: "span",
            display: "inline",
            children: [formattedDate, formattedTime]
          }),
          title: meeting.title || '',
          link: getLocation({
            meetingId: meeting.meetingId
          }),
          screenContext: _objectSpread({
            description: "Meeting card for \"".concat(meeting.title || 'Untitled meeting', "\""),
            id: meeting.meetingId
          }, userId && {
            state: {
              userId: userId
            }
          })
        }, meeting.meetingId);
      })
    })]
  });
}
export default MeetingSection;